import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.672 3.10666C18.2904 2.98267 17.8794 2.98267 17.4978 3.10666C17.2256 3.1951 17.0152 3.34551 16.8451 3.48993C16.6891 3.62237 16.518 3.79353 16.3382 3.97337L16.3171 3.99443L3.10156 17.21V21.3995H7.29102L20.5066 8.18389L20.5276 8.16285C20.7075 7.98304 20.8786 7.8119 21.0111 7.6559C21.1555 7.48578 21.3059 7.27542 21.3943 7.00326C21.5183 6.62165 21.5183 6.2106 21.3943 5.82899C21.3059 5.55683 21.1555 5.34647 21.0111 5.17635C20.8786 5.02036 20.7075 4.84923 20.5276 4.66943L19.8316 3.97339C19.6518 3.79354 19.4807 3.62237 19.3247 3.48993C19.1545 3.34551 18.9442 3.1951 18.672 3.10666ZM18.0142 4.84295C18.0532 4.8039 18.1165 4.8039 18.1556 4.84295L19.658 6.3454C19.6971 6.38446 19.6971 6.44777 19.658 6.48682L6.54542 19.5994H4.90155V17.9556L18.0142 4.84295Z",
		fill: "#D9D9D9"
	})
});
export default SvgIcPencil;
